import { render } from "./CofficientChart.vue?vue&type=template&id=d2851efc"
import script from "./CofficientChart.vue?vue&type=script&lang=js"
export * from "./CofficientChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__